module.exports = __webpack_public_path__ + "img/panda-bear.a41f9edb.png";